<template>
    <gofix-card fullContent class="mb-0">
        <div class="px-4 py-3">
            <gofix-button :label="!tableItems.length ? 'Add' : 'Edit'" @click="openModalItem"></gofix-button>
        </div>
        <!-- @row-click="openModalItem" -->
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            ref="gofixTable">
            <template slot="gofix_table:value" slot-scope="row">
                {{ row.item.value > 0 ? `+${row.item.value}` : row.item.value }}%
            </template>
            <template slot="gofix_table:payment_to_contractor" slot-scope="row">
                {{ `${Number(row.item.value) + 100}%` }}
            </template>
        </gofix-table>
        <b-modal :no-close-on-backdrop="true" id="modal-create-orders" :title="modal.title" hide-footer :centered="true" v-model="modal.open" ref="modal-create-orders">
                <b-form class="formV2">
                    <template v-for="(item, index) in settings">
                        <b-row :key="index" align-v="center">
                            <b-col md="12">
                                <gofix-form-input-number
                                    :label="item.name"
                                    v-model="item.value"
                                    :integer-limit="3"
                                    allowNegative
                                    suffix="%">
                                </gofix-form-input-number>
                            </b-col>
                            
                        </b-row>
                    </template>
                </b-form>
                <b-button-group class="d-block text-right pr-4">
                    <gofix-button label="SUBMIT" @click="saveItem" :loading="modal.loading" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
    </gofix-card>
</template>
<script>
const defaultValues = [
    {
        min: 80,
        max: 84,
        name: '80 - 84',
        value: null,
        month_ago: null
    },
    {
        min: 75,
        max: 79,
        name: '75 - 79',
        value: null,
        month_ago: null
    },
    {
        min: 70,
        max: 74,
        name: '70 - 74',
        value: null,
        month_ago: null
    },
    {
        min: 65,
        max: 69,
        name: '65 - 69',
        value: null,
        month_ago: null
    },
    {
        min: 62,
        max: 64,
        name: '62 - 64',
        value: null,
        month_ago: null
    },
    {
        min: 58,
        max: 61,
        name: '58 - 61',
        value: null,
        month_ago: null
    },
    {
        min: 55,
        max: 57,
        name: '55 - 57',
        value: null,
        month_ago: null
    },
    {
        min: 0,
        max: 54,
        name: '54 and below',
        value: null,
        month_ago: null
    }
]
export default {
    name: 'performance_assesment_lump_sum_payment',
    props: {
        propertyType: {
            type: String,
            default: '',
        },
        contract: {
            type: Object,
            default: () => null,
        }
    },
    data() {
        return {
            tableConfig:{
                name: 'performance-assesment-lump-sum-payment',
                controls:{
                    create: false,
                    update: false,
                    delete: false,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                    reload: false,
                    tablePagination: false,
                    tableFilter: false
                },
                filter: {
                    contract_id: {type: "number", value: null, function:"=", with: []},
                    property_type: {type: "text", value: "", function:"ilike", with: []},
                },
                page: 1,
                limit: 100,
                sortColumn: "id",
                sortDirection: "asc",
                fields: [
                    {
                        key: 'name',
                        label: 'Score',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width:300px",
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'value',
                        label: '% Deduction in Payment',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width:200px",
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'payment_to_contractor',
                        label: '% of Payment to Contractor',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width:300px",
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'auto',
                        label: '',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                ]
            },
            tableItems: [],
            supplier_contracts: [],
            modal: {
                title: '',
                open: false,
                loading: false,
            },
            settings: defaultValues,
            timer: {
                save: null
            }
        }
    },
    watch: {
        propertyType: function() {
            this.$refs.gofixTable.reloadTableItems();
        },
        contract: function() {
            this.$refs.gofixTable.reloadTableItems();
        }
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest , resolve,reject } = await callback();
            if(!this.contract || !this.propertyType) {
                this.tableItems = []
                this.tableConfig.total = 0
                resolve({
                    items: [],
                    total: 0
                })
                return
            }
            tableRequest.filter.property_type.value = this.propertyType
            tableRequest.filter.contract_id.value = this.contract.id
            tableRequest.type_setting = 'pa_lump_sum_payment_setting'
            await this.$store.dispatch("PerformanceAssesmentSettingsController/getItems", tableRequest)
            .then(response => {
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                resolve(response);
            })
            .catch(err => {
                this.$alertNotification("Can not load the lump sum payment", "danger");
                reject();
            })
        },
        async openModalItem(){
            if(this.tableItems.length){
                this.modal.title = 'Edit Lump Sum Payment'
                this.settings = JSON.parse(JSON.stringify(this.tableItems))
            } else {
                if(!this.propertyType) return this.$alertNotification("Please select a property type", "danger");
                if(!this.contract) return this.$alertNotification("Please select a supplier contract", "danger");
                this.modal.title = 'Create Lump Sum Payment'
                this.settings = JSON.parse(JSON.stringify(defaultValues))
            }

            this.modal.open = true;
        },
        saveItem() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(() => {
                const request = {
                    items: JSON.parse(JSON.stringify(this.settings)),
                    type_setting: 'pa_lump_sum_payment_setting'
                }

                let checkRequired = false
                let checkPercent = false
                request.items.map(item => {
                    if(item.value == '' || item.value == null) {
                        checkRequired = true;
                        return false
                    }

                    if(this.$accounting.unformat(item.value) > 100) {
                        checkPercent = true;
                        return false
                    }
                })

                if(checkRequired) return this.$alertNotification("Please enter all fields", "danger")
                if(checkPercent) return this.$alertNotification("Value must be less than or equal to 100%", "danger")
                if(this.modal.loading) return
                this.modal.loading = true

                request.items.forEach(item => {
                    if(!request.id) {
                        item.contract_id = this.contract.id
                        item.property_type = this.propertyType
                    }
                    item.value = this.$accounting.unformat(item.value)
                });
                this.$store.dispatch(`PerformanceAssesmentSettingsController/savePASettings`, request)
                    .then(response => {
                        this.modal.loading = false
                        this.modal.open = false
                        this.$refs.gofixTable.reloadTableItems();
                        this.$alertNotification(this.$notificationV2(!request.id ? 'adding' : 'editing', 'pa_maintenance_weight'));
                    })
                    .catch(err => {
                        console.log(err)
                        this.modal.loading = false
                        if (err.response.data.error && err.response.data.error.message) {
                            this.$alertNotification(err.response.data.error.message, "danger")
                        }
                    })
            }, 200)
        }
    }
}
</script>